<template>
  <div class="app-loader-host">
    <div class="loader">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
      <div class="bar4"></div>
      <div class="bar5"></div>
      <div class="bar6"></div>
    </div>
  </div>
</template>

<script>
/*
AppLoader — the app's six-bar boot loader, reusable from inside Vue.

XOL-446. The identical markup is hard-coded into `index.html` inside `#app`,
where it renders while the bundle downloads and is then replaced when Vue
mounts. This component exists so screens that need to wait on something after
boot show the *same* loader rather than inventing a second visual language.

The `.loader` / `.bar1`..`.bar6` CSS deliberately lives in `index.html`'s
inline <style> block, not here:

  * it must be applied before any bundle has loaded, so it cannot move into a
    component or an imported stylesheet;
  * copying it into a scoped block here would fork the animation and the six
    brand colours into two places that would drift.

So this component intentionally depends on those global classes. If you
change the loader's look, change it in `index.html` and both the boot screen
and every AppLoader follow.
*/
export default {
  name: 'app-loader'
}
</script>

<style scoped>
/* Positioning only — the bars themselves are styled by index.html.
   .loader is position:absolute against the nearest positioned ancestor, so
   give it one and a height to centre within. */
.app-loader-host {
  position: relative;
  width: 100%;
  min-height: 220px;
}
</style>
